export default __webpack_public_path__ + "static/media/chat-info.2361c2c7.svg";